import React from 'react';
import './PropertyCard1.css';
import MainBtn from './Btn';
import { Link } from 'react-router-dom';

const PropertyCard1 = (props) => {
    return ( 
        <>
        <div className={props.cardStyle}>
            <div className="propFloaties">
                <MainBtn btnText={props.floatyBaths} btnStyle="propFloaty" />
                <MainBtn btnText={props.floatyRooms} btnStyle="propFloaty" />
                <MainBtn btnText={props.floatyArea} btnStyle="propFloaty" />
            </div>
            <div className="propDetails">
                <span>{props.propertyName}</span>
                <p>{props.propertyDesc}</p>
                <Link className='link width100' to='/Details'>
                    <MainBtn btnText="MORE DETAILS" btnStyle="propertyCard1Btn" btnLink="/Details" />
                </Link>
            </div>
        </div>
        </>
     );
}
 
export default PropertyCard1;